/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from "react";
import Pagination from "../../../../widgets/pagination";
import CustomTable from "../../../../widgets/table";
import { reportServices } from "../../../../service/reportServices";
import Select, { ActionMeta, SingleValue } from "react-select";
import { useTranslation } from "react-i18next";
import { scheduleService } from "../../../../service/scheduleService";
import baseUrl from "../../../../service";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/constants";
import AlertModal from "../../../../widgets/alertModal";
import CustomToast from "../../../../widgets/toaster";
import { authToken } from "../../../../service/axiosConfig";
import { userService as userServices } from "../../../../service/userService";
import CustomLoader from "../../../../widgets/loader/loader";

// Define table column interfaces
interface TableColumn {
  Header: string;
  accessor: string;
}

// Production Batch Details Columns
export const productionBatchDetailsColumns: TableColumn[] = [
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Production Schedule Name",
    accessor: "production_schedule_name",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Production Type",
    accessor: "production_type",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Area Grade",
    accessor: "area_grade_names",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Plate Type Used",
    accessor: "plate_size_type_names",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Plate Batch Codes",
    accessor: "batch_numbers",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Saline Tube Batch Code",
    accessor: "saline_tube_batch_codes",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Product Name",
    accessor: "product_name",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Area Type",
    accessor: "area_type_names",
  },
  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Area Names",
    accessor: "area_names",
  },
  // {
  //   Header: "Media Types",
  //   accessor: "media_type_names",
  // },

  {
    Header: "productionBatchSummaryReport.productionBatchDetailsColumns.Swab Stick Batch Codes",
    accessor: "swab_batch_codes",
  },
];

// Incubation Details Columns
export const incubationDetailsColumns: TableColumn[] = [
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.Incubator ID",
    accessor: "incubator_names",
  },
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.Temperature Range",
    accessor: "temperature_range",
  },
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.Incubation Started By",
    accessor: "incubation_started_users",
  },
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.Start Time",
    accessor: "incubation_started_time",
  },
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.Ended By",
    accessor: "incubation_ended_users",
  },
  {
    Header: "productionBatchSummaryReport.incubationDetailsColumns.End Time",
    accessor: "incubation_ended_time",
  },
];

// Lab Details Columns
export const labDetailsColumns: TableColumn[] = [
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Observer 1 Name",
    accessor: "lab_observer_1_name",
  },
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Observer 2 Name",
    accessor: "lab_observer_2_name",
  },
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Observer 3 Name",
    accessor: "lab_observer_3_name",
  },
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Approved By",
    accessor: "lab_approved_by_user_name",
  },
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Approved Date",
    accessor: "approved_date",
  },
  {
    Header: "productionBatchSummaryReport.labDetailsColumns.Approval Status",
    accessor: "approval_status",
  },
];

// Activity Details Columns
export const activityDetailsColumns: TableColumn[] = [
  // {
  //   Header: 'Activity Type',
  //   accessor: 'activity_type_name',
  // },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Location Code",
    accessor: "location_code",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Location Name",
    accessor: "location_name",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Area Name",
    accessor: "area_name",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Plate Serial",
    accessor: "serial_number",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Start Date & Time",
    accessor: "start_date_time",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.End Date & Time",
    accessor: "end_date_time",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Equipment",
    accessor: "equipment",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Sampled By",
    accessor: "sampled_by",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Collected By",
    accessor: "collected_by",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.CFU Count",
    accessor: "cfu_count",
  },
  {
    Header: "productionBatchSummaryReport.activityDetailsColumns.Colony Type",
    accessor: "colony_type",
  },
  // {
  //   Header: 'Batch Number',
  //   accessor: 'batch_number',
  // },
  // {
  //   Header: 'Plate Size',
  //   accessor: 'plate_size_type_name',
  // },
  // {
  //   Header: 'Media Type',
  //   accessor: 'media_type_name',
  // },
];

interface ProductionBatchSummaryReportProps {
  ishide?: boolean;
  productionScheduleId?: any;
  filter?:any

}
interface ActivityDetail {
  activity_type_name: string;
  area_name: string;
  location_code: string;
  location_name: string;
  serial_number: string;
  batch_number: string;
  plate_size_type_name: string;
  media_type_name: string;
  start_date_time: string;
  end_date_time: string;
  sampled_by: string;
  collected_by?: string;
  equipment: string;
  cfu_count: string;
  colony_type: string;
}

type Filters = {
  productionSchedule: string;
  activityType: string;
  area: string;
  fromDate: string;
  toDate: string;
};

type OptionType = {
  value: string;
  label: string;
};

type ProductionScheduleOption = {
  value: string;
  label: string;
};

const ProductionBatchSummaryReport: React.FC<
  ProductionBatchSummaryReportProps
> = ({ ishide, productionScheduleId,
  filter = {} }) => {
  const { t } = useTranslation();

 

  // State for filters
  const [filters, setFilters] = useState<Filters>({
    productionSchedule: filter.productionSchedule || "",
    activityType:filter.activityType || "",
    area: filter.area || "",
    fromDate: filter.fromDate || "",
    toDate: filter.toDate || "",
  });

  // State for data
  const [productionBatchData, setProductionBatchData] = useState<Array<any>>(
    []
  );
  const [incubationDetailsData, setIncubationDetailsData] = useState<
    Array<any>
  >([]);
  const [labDetailsData, setLabDetailsData] = useState<Array<any>>([]);
  const [activityDetailsData, setActivityDetailsData] = useState<Array<any>>(
    []
  );

  // Other state variables
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");

  const [activityType, setActivityType] = useState<Array<any>>([]);
  const [areaList, setAreaList] = useState<Array<any>>([]);
  const [productionSchedules, setProductionSchedules] = useState<
    ProductionScheduleOption[]
  >([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [showDownloadCSV, setShowDownloadCSV] = useState(false);
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [authUserID, setAuthUserID] = useState("");
  const [pdfDownload, setpdfDownload] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [errors, setErrors] = useState<{ productionSchedule?: string }>({});
  const [isLoading, setIsLoading] = useState(false);
  // Add a new state for tracking if data should be shown
  const [showData, setShowData] = useState(false);
  const [permission, setPermission] = useState<string[]>([]);
  const sortRemoveList = [
    "production_schedule_name",
    "production_type",
    "area_grade_names",
    "plate_size_type_names",
    "batch_numbers",
    "saline_tube_batch_codes",
    "product_name",
    "area_type_names",
    "area_names",
    "swab_batch_codes",
    "incubator_names",
    "temperature_range",

    "incubation_started_users",

    "incubation_started_time",

    "incubation_ended_users",

    "incubation_ended_time",

    "lab_observer_1_name",

    "lab_observer_2_name",

    "lab_observer_3_name",

    "lab_approved_by_user_name",

    "approved_date",

    "approval_status",

    "location_code",

    "location_name",

    "area_name",

    "serial_number",

    "start_date_time",

    "end_date_time",

    "equipment",

    "sampled_by",

    "collected_by",

    "cfu_count",

    "colony_type",
  ];

  const transformApiDataToTables = (apiData: any) => {
    if (!apiData) {
      return {
        productionBatchDetails: [],
        incubationDetails: [],
        labDetails: [],
        activityDetails: [],
      };
    }

    // Production Batch Details
    const productionBatchDetails = [
      {
        production_schedule_name: apiData.production_schedule_name || "",
        product_name: apiData.product_name || "",
        production_type: apiData.production_type || "",
        area_names: apiData.area_names || "",
        area_type_names: apiData.area_type_names || "",
        area_grade_names: apiData.area_grade_names || "",
        batch_numbers: apiData.batch_numbers || "",
        plate_size_type_names: apiData.plate_size_type_names || "",
        media_type_names: apiData.media_type_names || "",
        saline_tube_batch_codes: apiData.saline_tube_batch_codes || "",
        swab_batch_codes: apiData.swab_batch_codes || "",
      },
    ];

    // Incubation Details
    const incubationDetails = [];
    if (apiData.first_incubator_names) {
      incubationDetails.push({
        incubator_names: apiData.first_incubator_names || "",
        temperature_range: apiData.first_incubator_temp_range || "",
        incubation_started_users: apiData.first_incubation_started_users || "",
        incubation_started_time: apiData.first_incubation_started_time || "",
        incubation_ended_users: apiData.first_incubation_ended_users || "",
        incubation_ended_time: apiData.first_incubation_ended_time || "",
      });
    }

    if (apiData.second_incubator_names) {
      incubationDetails.push({
        incubator_names: apiData.second_incubator_names || "",
        temperature_range: apiData.second_incubator_temp_range || "",
        incubation_started_users: apiData.second_incubation_started_users || "",
        incubation_started_time: apiData.second_incubation_started_time || "",
        incubation_ended_users: apiData.second_incubation_ended_users || "",
        incubation_ended_time: apiData.second_incubation_ended_time || "",
      });
    }

    // Lab Details
    const labDetails = [
      {
        lab_observer_1_name: apiData.lab_observer_1_name || "",
        lab_observer_2_name: apiData.lab_observer_2_name || "",
        lab_observer_3_name: apiData.lab_observer_3_name || "",
        lab_approved_by_user_name: apiData.lab_approved_by_user_name || "",
        approved_date: apiData.approved_date || "",
        approval_status: apiData.approval_status || "",
      },
    ];

    // Activity Details
    const activityDetails: ActivityDetail[] = [];

    // Process Active Air Sampling
    if (apiData.active_sampling_plate_details) {
      apiData.active_sampling_plate_details.forEach((plate: any) => {
        const activeSamplingDetail = plate.active_sampling_details?.[0] || {};
        const equipment = activeSamplingDetail.active_equipment_name || "";

        activityDetails.push({
          activity_type_name: "Active Air Sampling",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: activeSamplingDetail.start_date_time || "",
          end_date_time: activeSamplingDetail.end_date_time || "",
          sampled_by: `${activeSamplingDetail.created_by_first_name || ""} ${
            activeSamplingDetail.created_by_last_name || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${activeSamplingDetail.updated_by_first_name || ""} ${
            activeSamplingDetail.updated_by_last_name || ""
          }`.trim(),
          equipment: equipment,
        });
      });
    }

    // Process Passive Air Sampling
    if (apiData.passive_sampling_plate_details) {
      apiData.passive_sampling_plate_details.forEach((plate: any) => {
        const passiveSamplingDetail = plate.passive_sampling_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Passive Air Sampling",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: passiveSamplingDetail.start_date_time || "",
          end_date_time: passiveSamplingDetail.end_date_time || "",
          sampled_by: `${passiveSamplingDetail.created_by_first_name || ""} ${
            passiveSamplingDetail.created_by_last_name || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${passiveSamplingDetail.updated_by_first_name || ""} ${
            passiveSamplingDetail.updated_by_last_name || ""
          }`.trim(),
          equipment: passiveSamplingDetail.equipment_name || "",
        });
      });
    }

    // Process Contact Monitoring
    if (apiData.contact_monitoring_plate_details) {
      apiData.contact_monitoring_plate_details.forEach((plate: any) => {
        const contactMonitoringDetail =
          plate.contact_monitoring_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Contact Plate Monitoring",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: contactMonitoringDetail.start_date_time || "",
          end_date_time: contactMonitoringDetail.end_date_time || "",
          sampled_by: `${
            contactMonitoringDetail.started_by_user_firstname || ""
          } ${contactMonitoringDetail.started_by_user_lastname || ""}`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: "",
          equipment: contactMonitoringDetail.equipment_name || "",
        });
      });
    }

    // Process Glove Port Monitoring
    if (apiData.glove_port_monitoring_plate_details) {
      apiData.glove_port_monitoring_plate_details.forEach((plate: any) => {
        const glovePortDetail = plate.glove_port_monitoring_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Glove Port Monitoring",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: glovePortDetail.start_date_time || "",
          end_date_time: glovePortDetail.end_date_time || "",
          sampled_by: `${glovePortDetail.started_by_user_firstname || ""} ${
            glovePortDetail.started_by_user_lastname || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: "",
          equipment: glovePortDetail.equipment_name || "",
        });
      });
    }

    // Process Personnel Monitoring
    if (apiData.personal_monitoring_plate_details) {
      apiData.personal_monitoring_plate_details.forEach((plate: any) => {
        const personalMonitoringDetail =
          plate.personal_monitoring_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Personnel Monitoring",
          area_name: personalMonitoringDetail.location_name || "",
          location_code: plate.location_code || "",
          location_name: personalMonitoringDetail.finger_dab_option_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: personalMonitoringDetail.start_date_time || "",
          end_date_time: "",
          sampled_by: `${
            personalMonitoringDetail.started_by_user_firstname || ""
          } ${personalMonitoringDetail.started_by_user_lastname || ""}`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: "",
          equipment: personalMonitoringDetail.equipment_name || "",
        });
      });
    }

    // Process Sampling Plate
    if (apiData.sampling_plate_details) {
      apiData.sampling_plate_details.forEach((plate: any) => {
        const samplingDetail = plate.sampling_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Sampling Plate",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: samplingDetail.start_date_time || "",
          end_date_time: samplingDetail.end_date_time || "",
          sampled_by: `${samplingDetail.started_by_user_firstname || ""} ${
            samplingDetail.started_by_user_lastname || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${samplingDetail.updated_by_first_name || ""} ${
            samplingDetail.updated_by_last_name || ""
          }`.trim(),
          equipment: samplingDetail.equipment_name || "",
        });
      });
    }

     // Process anaerobic Plate
    if (apiData.anaerobic_plate_details) {
      apiData.anaerobic_plate_details.forEach((plate: any) => {
        const anaerobicPlateDetails = plate.anaerobic_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Anaerobic Monitoring",
           area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: anaerobicPlateDetails.start_date_time || "",
          end_date_time: anaerobicPlateDetails.end_date_time || "",
          sampled_by: `${anaerobicPlateDetails.created_by_first_name || ""} ${
            anaerobicPlateDetails.created_by_last_name || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${anaerobicPlateDetails.updated_by_first_name || ""} ${
            anaerobicPlateDetails.updated_by_last_name || ""
          }`.trim(),
          equipment: anaerobicPlateDetails.equipment_name || "",
        });
      });
    }

     // Process nitrogen_monitoring Plate
    if (apiData.nitrogen_monitoring_plate_details) {
      apiData.nitrogen_monitoring_plate_details.forEach((plate: any) => {
        const nitrogenPlateDetails = plate.nitrogen_monitoring_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Nitrogen Monitoring",
           area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: nitrogenPlateDetails.start_date_time || "",
          end_date_time: nitrogenPlateDetails.end_date_time || "",
          sampled_by: `${nitrogenPlateDetails.created_by_first_name || ""} ${
            nitrogenPlateDetails.created_by_last_name || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${nitrogenPlateDetails.updated_by_first_name || ""} ${
            nitrogenPlateDetails.updated_by_last_name || ""
          }`.trim(),
          equipment: nitrogenPlateDetails.active_equipment_name || "",
        });
      });
    }

     // Process compressed_air_monitoring Plate
    if (apiData.compressed_air_monitoring_plate_details) {
      apiData.compressed_air_monitoring_plate_details.forEach((plate: any) => {
        const compressedAirPlateDetails = plate.compressed_air_monitoring_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Compressed Air Monitoring",
           area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: compressedAirPlateDetails.start_date_time || "",
          end_date_time: compressedAirPlateDetails.end_date_time || "",
          sampled_by: `${compressedAirPlateDetails.created_by_first_name || ""} ${
            compressedAirPlateDetails.created_by_last_name || ""
          }`.trim(),
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: `${compressedAirPlateDetails.updated_by_first_name || ""} ${
            compressedAirPlateDetails.updated_by_last_name || ""
          }`.trim(),
          equipment: compressedAirPlateDetails.active_equipment_name || "",
        });
      });
    }

    // Process Swab Collection
    if (apiData.swab_collection_plate_details) {
      apiData.swab_collection_plate_details.forEach((plate: any) => {
        const swabDetail = plate.surface_monitoring_swab_details?.[0] || {};

        activityDetails.push({
          activity_type_name: "Surface Monitoring - Swab Collection",
          area_name: plate.area_name || "",
          location_code: plate.location_code || "",
          location_name: plate.location_name || "",
          serial_number: plate.serial_number || "",
          batch_number: plate.batch_number || "",
          plate_size_type_name: plate.plate_size_type_name || "",
          media_type_name: plate.media_type_name || "",
          start_date_time: swabDetail.start_date_time || "",
          end_date_time: swabDetail.end_date_time || "",
          sampled_by: swabDetail.started_operator_name || "",
          cfu_count: plate.cfu_count || "",
          colony_type: plate.colony_type || "",
          collected_by: "",
          equipment: swabDetail.equipment_name || "",
        });
      });
    }

    return {
      productionBatchDetails,
      incubationDetails,
      labDetails,
      activityDetails,
    };
  };

  const getProductionBatchSummary = async (initialLoad = false) => {
    try {
      let response;
      if (initialLoad) {
        // On initial load, don't fetch data, just show the prompt
        setShowData(false);
        return;
      } else {
        response = await reportServices.productionBatchSummaryReport(
          filters.productionSchedule || productionScheduleId,
          filters.activityType,
          filters.area
        );
      }

      if (response?.status && response.statusCode === 200) {
        const transformedData = transformApiDataToTables(response.data);

        setProductionBatchData(transformedData.productionBatchDetails);
        setIncubationDetailsData(transformedData.incubationDetails);
        setLabDetailsData(transformedData.labDetails);
        setActivityDetailsData(transformedData.activityDetails);

        setTotalPages(1);
        setTotalElements(transformedData.activityDetails.length);
        setShowData(true); // Show data only when we have a successful response
      } else {
        setProductionBatchData([]);
        setIncubationDetailsData([]);
        setLabDetailsData([]);
        setActivityDetailsData([]);
        setTotalPages(0);
        setTotalElements(0);
        setShowData(false);
      }
    } catch (error) {
      console.error("Error fetching production batch summary", error);
      setToastType("error");
      setToastMessage("Failed to fetch production batch summary");
      setShowToast(true);

      setProductionBatchData([]);
      setIncubationDetailsData([]);
      setLabDetailsData([]);
      setActivityDetailsData([]);
      setShowData(false);
    }
  };

  const handleApplyClick = async () => {
    const errors: { productionSchedule?: string } = {};
    if (!filters.productionSchedule) {
      errors.productionSchedule = "Please Select Production Schedule";
    }
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }
    setErrors({});
    setShowDownloadCSV(false);
    setIsApplyClicked(true);
    setIsLoading(true);
    try {
      await getProductionBatchSummary();
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (newPage: any, pageSize?: number) => {
    setPage(newPage);
    if (pageSize) {
      setPageSize(pageSize);
    }
    setUseEffectRequired(true);
  };

  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  const getProductionSchedules = async (areaId: string = "") => {
    try {
      const response = await scheduleService.getCompletedProductionSchedulesReport(
        areaId
      );
      if (response.status && response.statusCode === 200) {
        const scheduleOptions = response.data.map((item: any) => ({
          value: item.id,
          label: item.production_schedule_name,
        }));
        setProductionSchedules(scheduleOptions);
      }
    } catch (error) {
      console.error("Error fetching production schedules", error);
    }
  };

  const getActivityTypeList = async () => {
    try {
      const response = await scheduleService.getActivityTypeList();
      if (response.status && response.statusCode === 200) {
        setActivityType(response.data);
      }
    } catch (error) {
      console.error("Error fetching activity types", error);
    }
  };

  const getAreaList = async () => {
    try {
      const response = await scheduleService.getAreaList("id", "desc", "6,17");
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                  grade_name: element.grade_name,
                };
              }
            );
            setAreaList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  const handleChange = (
    eventOrValue:
      | React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
      | SingleValue<OptionType>,
    actionOrUndefined?: ActionMeta<OptionType>
  ) => {
    let newFilters: Filters;

    if (actionOrUndefined) {
      const { name } = actionOrUndefined as { name: string };
      newFilters = {
        ...filters,
        [name]: (eventOrValue as SingleValue<OptionType>)?.value || "",
      };

      if (name === "area") {
        getProductionSchedules(
          (eventOrValue as SingleValue<OptionType>)?.value || ""
        );
      }
    } else {
      const { name, value } = (
        eventOrValue as React.ChangeEvent<HTMLSelectElement | HTMLInputElement>
      ).target;
      newFilters = { ...filters, [name]: value };
    }

    setFilters(newFilters);
    setIsApplyClicked(false);
    setShowDownloadCSV(true);
  };

  const handleCancel = () => {
    const initialFormData = {
      productionSchedule: "",
      activityType: "",
      area: "",
      fromDate: "",
      toDate: "",
    };
    setFilters(initialFormData);
    setShowDownloadCSV(true);
    setUseEffectRequired(true);
    setShowData(false); // Hide data when cancel is clicked
    getProductionBatchSummary(true); // Reset to initial state
  };

  const downloadReportCSV = async () => {
    
      const url = `${baseUrl}/summary/export_production_batch_summary_data?schedule_production_id=${
        filters.productionSchedule || productionScheduleId
      }&auth_id=${authUserID}&is_completed=1`;

       try {
            const res = await fetch(url, {
              headers: {
                'x-auth-token': authToken,
                'x-userid': authUserID,
                'Content-Type': 'application/json'
              }
            });
            const response = await res.json();
      
            if (res.ok && response.statusCode === 200) {
              setToastType("success");
              setToastMessage(response.message || "Downloaded successfully");
              setShowDownloadCSV(true);
            } else {
              setToastType("error");
              setToastMessage(response.message || "Something went wrong");
            }
            setShowToast(true);
          } catch (error) {
            setToastType("error");
            setToastMessage("Failed to fetch air sampling summary");
            setShowToast(true);
          }
        };

  useEffect(() => {
    const storedData = localStorage.getItem("userDetails");
    if (storedData) {
      const storedObject = JSON.parse(storedData);
      setAuthUserID(storedObject[0].x_userid);
      getPermissionByRole(storedObject[0].role_master_id);
    }

    if (ishide) {
      getProductionBatchSummary(false);
    } else {
      getProductionSchedules();
      getActivityTypeList();
      getAreaList();
      getProductionBatchSummary(true); // Pass true for initial load
    }
    setUseEffectRequired(false);
  }, []);

  const getPermissionByRole = async (role : number) => {
              try {
                const response = await userServices.getPermissionByRole(role);
                if(response.status && response.statusCode === 200){
                  setPermission(response.data.permissions)
                }
              } catch (error) {
                console.error(error);
              }
            }

  return (
    <div>
      {isLoading && <CustomLoader />}
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />

      {/* Filter Section */}
      {!ishide && (
        <div className="filter-component">
          <div className="filter-row">
            <div>
              <label htmlFor="productionScheduleSelect">
                Production Schedule
              </label>
            </div>
            <div>
              <div style={{ zIndex: "10" }}>
                <Select
                  options={productionSchedules}
                  onChange={handleChange}
                  name="productionSchedule"
                  placeholder="Select"
                  value={
                    productionSchedules.find(
                      (option: any) =>
                        option.value === filters.productionSchedule
                    ) || null
                  }
                  isSearchable={true}
                  isClearable
                  className="areaTypeSelect2"
                />
              </div>
              {errors.productionSchedule && (
                <p className="errorText">{errors.productionSchedule}</p>
              )}
            </div>
          </div>

          {/* <div className="filter-row">
        <div>
          <label htmlFor="areaTypeSelect" className='filter-label'>Area</label>
        </div>
        <div>
          <select 
            className='areaTypeSelect mx-1 py-2 mb-2' 
            name='area' 
            value={filters.area} 
            onChange={handleChange}
          >
            <option value="">Select</option>
            {areaList?.map((area) => (
              <option key={area.id} value={area.id}>
                {area.name}
              </option>
            ))}
          </select>
        </div>
      </div> */}

          {/* <div className="filter-row">
        <div>
          <label htmlFor="activityTypeSelect" className='filter-label'>Activity</label>
        </div>
        <div>
          <select 
            className='areaTypeSelect mx-1 py-2 mb-2' 
            name='activityType' 
            value={filters.activityType} 
            onChange={handleChange}
          >
            <option value="">Select</option>
            {activityType?.map((activity) => (
              <option key={activity.id} value={activity.id}>
                {activity.name}
              </option>
            ))}
          </select>
        </div>
      </div> */}
        </div>
      )}

      <div className="mx-2 d-flex justify-content-end">
        {!ishide && (
          <>
            <button
              className="analyticalFilterClose"
              title="Click here to Reset Filter"
              onClick={handleCancel}
            >
              {t("buttons.cancel")}
            </button>
           <button 
            className={isApplyClicked || isLoading ? "analyticalFilterApplyDisabledDownload" : "analyticalFilterApply"}
            disabled={isApplyClicked || isLoading} 
            onClick={handleApplyClick} 
            title="Click here to Apply Filter" >
                {t("buttons.apply")}
            </button>
          {permission.includes("generate_report") && (
        <button 
            className={!isApplyClicked || showDownloadCSV ? "analyticalFilterDisabledDownload" : "analyticalFilterDownload"}
            disabled={!isApplyClicked || showDownloadCSV} 
            onClick={downloadReportCSV}
            title={!isApplyClicked ? "Please apply filters first" : showDownloadCSV ? "Report already generated" : "Click here to Generate Report"}>
            {"Generate Report"}
            </button>
          )}
        </>
         )}
      </div>

      {!showData ? (
        !ishide && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="text-center">
            <h4>Please select a Production Schedule to Proceed</h4>
            {/* <p>You can also apply additional filters for more specific results</p> */}
          </div>
        </div>
        )
      ) : (
        <>
          {/* Production Batch Details Table */}
          <div className="mx-3 pe-2">
            <CustomTable
              data={productionBatchData}
              columns={productionBatchDetailsColumns}
              isEditable={false}
              totalElements={productionBatchData.length}
              isActionVisible={false}
              isViewVisible={false}
              isSeachable={false}
              tableHead={"Production Batch Details"}
              showBatchFilter={false}
              showLotCodeFilter={false}
              showSerielNoFilter={false}
              onSortClick={handleSort}
              removeSortList={sortRemoveList}
            />
          </div>

          {/* Incubation Details Table */}
          <div className="mx-3 pe-2">
            <CustomTable
              data={incubationDetailsData}
              columns={incubationDetailsColumns}
              isEditable={false}
              totalElements={incubationDetailsData.length}
              isActionVisible={false}
              isViewVisible={false}
              isSeachable={false}
              tableHead={"Incubation Details"}
              showBatchFilter={false}
              showLotCodeFilter={false}
              showSerielNoFilter={false}
              onSortClick={handleSort}
              removeSortList={sortRemoveList}
            />
          </div>

          {/* Lab Details Table */}
          <div className="mx-3 pe-2">
            <CustomTable
              data={labDetailsData}
              columns={labDetailsColumns}
              isEditable={false}
              totalElements={labDetailsData.length}
              isActionVisible={false}
              isViewVisible={false}
              isSeachable={false}
              tableHead={"Lab Details"}
              showBatchFilter={false}
              showLotCodeFilter={false}
              showSerielNoFilter={false}
              onSortClick={handleSort}
              removeSortList={sortRemoveList}
            />
          </div>

          {/* Activity Details Tables */}
          <div className="mx-3 pe-2" style={{ height: "45vh" }}>
            {activityDetailsData.some(
              (item) => item.activity_type_name === "Passive Air Sampling"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Passive Air Sampling"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Passive Air Sampling"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details - Passive Air Sampling"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

            {/* Only show tables for activity types that have data */}
            {activityDetailsData.some(
              (item) => item.activity_type_name === "Active Air Sampling"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Active Air Sampling"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Active Air Sampling"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details - Active Air Sampling"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

            {activityDetailsData.some(
              (item) => item.activity_type_name === "Contact Plate Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) =>
                    item.activity_type_name === "Contact Plate Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) =>
                      item.activity_type_name === "Contact Plate Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details - Contact Plate Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

            {activityDetailsData.some(
              (item) => item.activity_type_name === "Glove Port Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Glove Port Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) =>
                      item.activity_type_name === "Glove Port Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details - Glove Port Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}
            {activityDetailsData.some(
              (item) =>
                item.activity_type_name ===
                "Surface Monitoring - Swab Collection"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) =>
                    item.activity_type_name ===
                    "Surface Monitoring - Swab Collection"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) =>
                      item.activity_type_name ===
                      "Surface Monitoring - Swab Collection"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={
                  "Activity Details - Surface Monitoring - Swab Collection"
                }
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

            {activityDetailsData.some(
              (item) => item.activity_type_name === "Personnel Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Personnel Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Personnel Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details - Personnel Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

            {activityDetailsData.some(
              (item) => item.activity_type_name === "Sampling Plate"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Sampling Plate"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Sampling Plate"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details -  Sampling Plate"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

             {activityDetailsData.some(
              (item) => item.activity_type_name === "Anaerobic Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Anaerobic Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Anaerobic Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details -  Anaerobic Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

             {activityDetailsData.some(
              (item) => item.activity_type_name === "Nitrogen Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Nitrogen Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Nitrogen Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details -  Nitrogen Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

             {activityDetailsData.some(
              (item) => item.activity_type_name === "Compressed Air Monitoring"
            ) && (
              <CustomTable
                data={activityDetailsData.filter(
                  (item) => item.activity_type_name === "Compressed Air Monitoring"
                )}
                columns={activityDetailsColumns}
                isEditable={false}
                totalElements={
                  activityDetailsData.filter(
                    (item) => item.activity_type_name === "Compressed Air Monitoring"
                  ).length
                }
                isActionVisible={false}
                isViewVisible={false}
                isSeachable={false}
                tableHead={"Activity Details -  Compressed Air Monitoring"}
                showBatchFilter={false}
                showLotCodeFilter={false}
                showSerielNoFilter={false}
                onSortClick={handleSort}
                removeSortList={sortRemoveList}
              />
            )}

          </div>

          <div>
            <Pagination
              page={page}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </>
      )}

      <AlertModal
        show={pdfDownload}
        onHide={() => setpdfDownload(false)}
        title="Alert"
        message={t("downloadPdf.download")}
        onConfirm={downloadReportCSV}
      />
    </div>
  );
};

export default ProductionBatchSummaryReport;
